module.exports = __webpack_public_path__ + "prod/1.42.2/img/solution_two.3de15477.png";